module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/2-5mill-inactive-0552bd7be7edd429969049a320dcc4ac.png";